import { Equipment } from "@/modules/maintenance/services";

export class MonitorEquipment extends Equipment {
    sensors: any[];
    status: string;
}